import { memo, useCallback } from 'react';
import { removeIdFromArray } from './helpers';
// eslint-disable-next-line import/no-cycle
import SlideViewerMultipleChoiceAnswerCard from './SlideViewerMultipleChoiceAnswerCard';

function SlideViewerMultipleChoiceQuestionCards({
  answerIds = [],
  answersToMap = [],
  disableSubmitButton = false,
  hasResults = false,
  hasSubmitted = false,
  onAnswerSelect,
  setSubmitAnswer,
  showAnswersInSidebar = false,
}) {
  const handleAnswerClick = useCallback(
    (answerId) => {
      // Ensure answerIds is always an array
      const currentAnswerIds = Array.isArray(answerIds) ? answerIds : [];

      const newAnswerIds = currentAnswerIds.includes(answerId)
        ? removeIdFromArray(currentAnswerIds, answerId) // Fixed parameter order
        : [...currentAnswerIds, answerId];

      if (onAnswerSelect) {
        onAnswerSelect(newAnswerIds);
      }

      if (setSubmitAnswer) {
        setSubmitAnswer(newAnswerIds);
      }
    },
    [answerIds, onAnswerSelect, setSubmitAnswer],
  );

  return (
    <div className="mt-4 grid gap-4 grid-cols-1 lg:grid-cols-2 clear-both">
      {answersToMap.map((answer, index) => {
        const answerId = parseInt(answer.id, 10);
        const isSelected = answerIds.includes(answerId);
        const answerIsSelected =
          isSelected && (hasSubmitted || disableSubmitButton);

        return (
          <SlideViewerMultipleChoiceAnswerCard
            key={answer.id}
            answer={answer}
            disabled={disableSubmitButton}
            hasResults={hasResults}
            index={index}
            isClicked={answerIsSelected}
            selectAnswer={() => handleAnswerClick(answerId)}
            showAnswersInSidebar={showAnswersInSidebar}
          />
        );
      })}
    </div>
  );
}

export default memo(SlideViewerMultipleChoiceQuestionCards);
